export const breakpointsList = {
    'mobile': 320,
    'mobileLandscape': 480,
    'tablet': 768,
    'desktop': 1024,
    'desktopLarge': 1110,
    'desktopWide': 1500,
};